import { ProductShadePickerDropdown } from './ProductShadePickerDropdown';
import styled from 'styled-components';
import * as React from 'react';
import { observer } from 'mobx-react';
import { Breakpoints } from 'elc-base-theme';
import { classes } from '../../utils/Classes';
import { Desktop, Mobile } from 'elc-layouts';
import { ProductShadePickerComponentViewController } from '../../controllers/ProductShadePickerComponentViewController';
import { IShadePickeComponent } from '../../interfaces/IShadePicker';
import { config } from 'elc-service';

const ProductShadePickerModal = styled(ProductShadePickerDropdown)`
    & .elc-dropdown-options {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.5);
    }

    & .elc-dropdown-options-list {
        max-height: 100%;
        position: absolute;
        bottom: 0;
    }
`;
@config(['shadeDropdown'])
@observer
export class ProductShadePickerComponent extends React.Component<IShadePickeComponent> {
    private viewController: ProductShadePickerComponentViewController;

    constructor(props: IShadePickeComponent) {
        super(props);
        this.viewController = props.viewController;
        this.viewController.initialize(props);
    }

    public render() {
        const { shadeDropdownProps } = this.props;

        const {
            productId,
            shades,
            selectedShade,
            onShadeSelect,
            useDropup,
            hideDropdownArrow
        } = shadeDropdownProps;

        const { componentConfig } = this.viewController.data;

        const shadesDropdownClassNames = classes('shades-dropdown');

        const shadesDropdownComponentClassNames = classes('shades-dropdown-component');

        return (
            <div className={shadesDropdownComponentClassNames}>
                <Desktop minWidth={Breakpoints.desktop}>
                    {() => (
                        <ProductShadePickerDropdown
                            className={shadesDropdownClassNames}
                            shades={shades}
                            selectedShade={selectedShade}
                            selectedHexValue={selectedShade.hexVal}
                            onShadeSelect={onShadeSelect}
                            useDropup={useDropup}
                            hideDropdownArrow={hideDropdownArrow}
                            productId={productId}
                            shadeSettings={componentConfig}
                        />
                    )}
                </Desktop>
                <Mobile maxWidth={Breakpoints.desktop - 1}>
                    {() => (
                        <ProductShadePickerModal
                            className={shadesDropdownClassNames}
                            shades={shades}
                            selectedShade={selectedShade}
                            selectedHexValue={selectedShade.hexVal}
                            onShadeSelect={onShadeSelect}
                            hideDropdownArrow={hideDropdownArrow}
                            productId={productId}
                            shadeSettings={componentConfig}
                        />
                    )}
                </Mobile>
            </div>
        );
    }
}
